import { useLocales } from "expo-localization";
import { Platform } from "react-native";
import { getCountryCodeFromTimezone } from "./get-country-code-from-timezone";

export function useGetCountryCode(): string {
  const locales = useLocales();
  if (Platform.OS === "web") {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return getCountryCodeFromTimezone(tz);
  }

  if (locales.length === 0) {
    return "";
  }

  const [primaryLocale] = locales;
  return primaryLocale.regionCode ?? "";
}
